import { Dispatch, SetStateAction } from 'react'

import {
  BEHAVIOR_LOG_SEARCH_CONDITION_CLEAR,
  BehaviorLogSearchCondition
} from '@/common/api/modules/behaviorLog'
import { isSameSearchCondition } from '@/common/api/search'
import { behaviorActionTypeName } from '@/common/app/modules/recommend/behaviorLog'
import { BehaviorActionType } from '@/common/model/recommend/behavior'

import Button from '@/components/view/atoms/button/Button'
import TextField, { TextBoxSize } from '@/components/view/atoms/textfield/TextField'
import SearchConditionAreaContent from '@/components/view/layouts/area/SearchConditionAreaContent'
import SortButtonList from '@/components/view/layouts/button/SortButtonList'
import FormRow from '@/components/view/layouts/form/FormRow'
import DisclosureSortDateBetweenButton from '@/components/view/molecules/disclosure/DisclosureSortDateBetweenButton'
import DisclosureSortKeyword from '@/components/view/molecules/disclosure/DisclosureSortKeyword'
import DisclosureSortRadioSelect from '@/components/view/molecules/disclosure/DisclosureSortRadioSelect'

interface Props {
  condition: BehaviorLogSearchCondition
  setCondition: Dispatch<SetStateAction<BehaviorLogSearchCondition>>
}

const BehaviorSearchConditionField = ({ condition, setCondition }: Props) => {
  const isDefault = isSameSearchCondition(condition, BEHAVIOR_LOG_SEARCH_CONDITION_CLEAR)
  const dateQuantity = [condition.dateFrom, condition.dateTo].filter(Boolean).length

  return (
    <SearchConditionAreaContent>
      <FormRow gap={8} size={TextBoxSize.FULL} align='center'>
        <TextField
          type='search'
          size={TextBoxSize.FULL}
          value={condition.keyword ?? ''}
          onChange={(e) =>
            setCondition((c) => ({ ...c, page: 1, keyword: e.target.value || null }))
          }
          placeholder='クッキーID、商品ID、顧客ID、ページURLで検索...'
        />
      </FormRow>
      <SortButtonList>
        <DisclosureSortRadioSelect
          name='actionType'
          currentValue={condition.actionType}
          choices={[
            {
              name: 'すべて',
              value: null
            },
            ...Object.values(BehaviorActionType).map((value) => ({
              name: behaviorActionTypeName(value),
              value
            }))
          ]}
          setCondition={setCondition}
        >
          アクション
        </DisclosureSortRadioSelect>
        <DisclosureSortKeyword
          setCondition={setCondition}
          label='クッキーID'
          name='visitorId'
          currentValue={condition.visitorId}
          placeholder='部分一致'
        />
        <DisclosureSortKeyword
          setCondition={setCondition}
          label='商品ID'
          name='itemId'
          currentValue={condition.itemId}
          placeholder='部分一致'
        />
        <DisclosureSortKeyword
          setCondition={setCondition}
          label='カテゴリID'
          name='categoryId'
          currentValue={condition.categoryId}
          placeholder='部分一致'
        />
        <DisclosureSortKeyword
          setCondition={setCondition}
          label='顧客ID'
          name='customerId'
          currentValue={condition.customerId}
          placeholder='部分一致'
        />
        <DisclosureSortDateBetweenButton
          quantity={dateQuantity}
          defaultStartValue={condition.dateFrom}
          defaultEndValue={condition.dateTo}
          onComplete={(start, end) =>
            setCondition((c) => ({
              ...c,
              page: 1,
              dateFrom: start || null,
              dateTo: end || null
            }))
          }
        >
          期間
        </DisclosureSortDateBetweenButton>
        <Button
          color='secondary'
          disabled={isDefault}
          onClick={() => setCondition(BEHAVIOR_LOG_SEARCH_CONDITION_CLEAR)}
        >
          条件をリセット
        </Button>
      </SortButtonList>
    </SearchConditionAreaContent>
  )
}

export default BehaviorSearchConditionField
